import { marxy } from '../initMarxy'
import { safeMarxyCall, marxyDeprecatedApi } from '../helpers'
import { MarxyEvents, MarxyProperties } from '~/utils/marxy/types'

/**
 * Tracks an update in the cart
 *
 * IMPORTANT
 * This function is connected to the Marxy SDK (window.marxy.eventTracking).
 * Never call this function directly. This would wrap the function in a bad JS chunk,
 * duplicate the initialization of the Marxy SDK, and possibly incorrect behaviour.
 *
 * @param properties
 */
const trackCartUpdate = (properties: MarxyProperties) => {
  safeMarxyCall(() => {
    // Fallback for old API version
    if (properties && properties.update) {
      properties = properties.update
      marxyDeprecatedApi('trackCartUpdate')
    }
    marxy.trackEvent(MarxyEvents.CART_UPDATE, properties)
  })
}

// TODO:
// marxy.registerEvent('trackCartUpdate', trackCartUpdate)

export default trackCartUpdate
